export interface RichTextDescriptionProps {
  description: string
  className?: string
}

export const RichTextDescription: React.FC<RichTextDescriptionProps> = ({
  description,
  className = '',
}) => {
  return (
    <section
      className={className}
      dangerouslySetInnerHTML={{ __html: description }}
    />
  )
}
